import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.77515 4.80439C3.58945 4.80439 3.43891 4.95493 3.43891 5.14063V7.38222C3.43891 7.69172 3.18801 7.94262 2.87851 7.94262C2.56901 7.94262 2.31812 7.69172 2.31812 7.38222V5.14063C2.31812 4.33593 2.97045 3.68359 3.77515 3.68359H6.46506C6.77456 3.68359 7.02546 3.93449 7.02546 4.24399C7.02546 4.55349 6.77456 4.80439 6.46506 4.80439H3.77515Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.77515 15.7894C3.58945 15.7894 3.43891 15.6388 3.43891 15.4531V13.2115C3.43891 12.902 3.18801 12.6511 2.87851 12.6511C2.56901 12.6511 2.31812 12.902 2.31812 13.2115V15.4531C2.31812 16.2578 2.97045 16.9102 3.77515 16.9102H6.46506C6.77456 16.9102 7.02546 16.6593 7.02546 16.3498C7.02546 16.0403 6.77456 15.7894 6.46506 15.7894H3.77515Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.2246 4.80439C17.4103 4.80439 17.5608 4.95493 17.5608 5.14063V7.38222C17.5608 7.69172 17.8117 7.94262 18.1212 7.94262C18.4307 7.94262 18.6816 7.69172 18.6816 7.38222V5.14063C18.6816 4.33593 18.0293 3.68359 17.2246 3.68359H14.5347C14.2252 3.68359 13.9743 3.93449 13.9743 4.24399C13.9743 4.55349 14.2252 4.80439 14.5347 4.80439H17.2246Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.2246 15.7894C17.4103 15.7894 17.5608 15.6388 17.5608 15.4531V13.2115C17.5608 12.902 17.8117 12.6511 18.1212 12.6511C18.4307 12.6511 18.6816 12.902 18.6816 13.2115V15.4531C18.6816 16.2578 18.0293 16.9102 17.2246 16.9102H14.5347C14.2252 16.9102 13.9743 16.6593 13.9743 16.3498C13.9743 16.0403 14.2252 15.7894 14.5347 15.7894H17.2246Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("path", {
  d: "M2.77271 10.2951C2.77271 9.91854 3.07797 9.61328 3.45452 9.61328H4.59089V10.9769H3.45452C3.07797 10.9769 2.77271 10.6717 2.77271 10.2951Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("path", {
  d: "M18.2273 10.2951C18.2273 9.91854 17.922 9.61328 17.5455 9.61328H16.4091V10.9769H17.5455C17.922 10.9769 18.2273 10.6717 18.2273 10.2951Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.49991 5.97656C4.99783 5.97656 4.59082 6.38358 4.59082 6.88565V9.61293H16.409V6.88565C16.409 6.38358 16.002 5.97656 15.4999 5.97656H5.49991ZM16.409 10.9766H4.59082V13.7038C4.59082 14.2059 4.99783 14.6129 5.49991 14.6129H15.4999C16.002 14.6129 16.409 14.2059 16.409 13.7038V10.9766Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8
  ]))
}